import Fetch from "./Fetch";

import { API_BASIC_URL_SLOT_SERVICE } from "../config/constants";
import { handleError, handleResponse } from "./ApiUtils";

export const fetchPosZoneServiceTypeList = (data) => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/delivery-bag/pos-zone-service-mapping`, data).then(handleResponse).catch(handleError);
};

export const fetchSlotUtilizationRecord = (data) => {
  return Fetch.create(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/slots/utilization-dashboard/${data.currentCountryId}`, data.payload).then(handleResponse).catch(handleError);
};

export const getAdvanceDayCalculate = (countryId) => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/country/${countryId}`).then(handleResponse).catch(handleError);
};
